import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "../lib/auth";
import { BRAND_LOGO } from "../lib/brand";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role === "super_admin") nav("/admin");
      else if (u.role === "merchant_owner" || u.role === "cashier") nav("/scanner");
      else nav("/me");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6 grain relative">
      <div className="max-w-md w-full">
        <div className="text-center mb-10">
          <Link to="/" className="inline-flex flex-col items-center gap-2">
            <img src={BRAND_LOGO} alt="" className="h-16 w-16 rounded-full ring-1 ring-[#D4AF37]/40" />
            <p className="font-display text-2xl text-white tracking-wide">THE SOCIAL CIRCLE</p>
            <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">by Cornerstone</p>
          </Link>
        </div>

        <div className="tsc-card p-8" data-testid="login-card">
          <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">Welcome back</p>
          <h1 className="mt-2 font-display text-3xl text-white">Sign in</h1>
          <form onSubmit={submit} className="mt-7 space-y-4">
            <div>
              <label className="text-[10px] tracking-luxe uppercase text-white/60">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="tsc-input mt-1.5" data-testid="login-email" />
            </div>
            <div>
              <label className="text-[10px] tracking-luxe uppercase text-white/60">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="tsc-input mt-1.5" data-testid="login-password" />
            </div>
            <button type="submit" disabled={loading} className="tsc-btn-gold w-full" data-testid="login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <p className="text-white/55 text-xs mt-6 text-center">Not yet a member? <Link to="/register" className="text-[#D4AF37]" data-testid="login-to-register">Join the Circle</Link></p>
        </div>
      </div>
    </div>
  );
}
